





































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import {QueryUnit, CreateUnit, EditUnit} from '../../../api/basicDictionary'
import {QueryTenant} from '../../../api/shipmentsManagement'

import myform from '../../../components/form/index.vue'
import {GetManufacturerList, InsertManufacturer, UpdateManufacturer} from "@/api/machines"

@Component({
    components: {myTable, myform}
})
export default class extends AbpBase {
    query: any = {
        manufacturerName: '',
        status: true,
    }
    list: Array<object> = []
    formShow: boolean = false
    formTitle: string = ''
    formData: object = {}
    formItem: Array<object> = []

    created() {
        this.getData()
    }

    async getData() {
        this.table.loading = true
        let res = await GetManufacturerList({...this.table, ...this.query})
        this.table.totalCount = res.totalCount;
        this.list = res.items;
        this.table.loading = false
    }

    pageChange(page: number) {
        this.table.page = page
        this.getData();
    }

    pagesizeChange(pagesize: number) {
        this.table.pageSize = pagesize
        this.getData();
    }

    addOrEdit(row: object) {
        this.formTitle = !row ? '新增' : '编辑'
        this.formData = {
            manufacturerName: '',
            contact: '',
            telephone: '',
            address: '',
            status: true,
        }
        this.formData = Object.assign(this.formData, row)
        this.formItem = [
            {
                column: 24,
                show: true,
                label: '维护保养商名称',
                name: 'manufacturerName',
                type: 'text',
                width: '400px',
                placeholder: '请输入维护保养商名称',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 24,
                show: true,
                label: '联系人',
                name: 'contact',
                type: 'text',
                placeholder: '请输入联系人',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 24,
                show: true,
                label: '联系人电话',
                name: 'telephone',
                type: 'text',
                placeholder: '请输入联系人电话',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 24,
                show: true,
                label: '地址',
                name: 'address',
                type: 'text',
                placeholder: '请输入地址',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 24,
                show: true,
                label: '是否激活',
                name: 'status',
                type: 'switch',
            }
        ]
        this.formShow = true
    }

    async submit(data: any) {
        let res;
        if (data.id) {
            res = await UpdateManufacturer(data)
        } else {
            res = await InsertManufacturer(data)
        }
        if (2000 === res.code) {
            this.formShow = false
            this.getData()
        }
    }

    columns: Array<object> = [
        {title: "维修保养商名称", key: "manufacturerName"},
        {title: "联系人", key: "contact"},
        {title: "联系电话", key: "telephone"},
        {title: "地址", key: "address"},
        {
            title: '操作',
            width: '80',
            render: (h: any, p: any) => {
                return h('el-button', {
                    props: {
                        type: 'text',
                        size: 'small'
                    },
                    directives:[{
                        name:'allow'
                    }],
                    on: {
                        click: () => {
                            this.addOrEdit(p.row)
                        }
                    }
                }, '编辑')
            }
        },
    ]
}
